import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import StepToShowComponent from "../../components/Step";
import { FireAssuranceProvider } from "./FireAssuranceContext";
import { SpaceBox } from "../../components/Space";
import PaymentErrorModalComponent from "../../components/PaymentErrorModal";
import { STEPS } from "../../data/fireAssurance";
import OrderService from "../../service/order";
import MoneyLogo1 from "../../images/money-1.svg";
import { BANK_DEFAULT_SELECT } from "../../const";
import DecoratedGraphic from "../../images/graphic.png";
import FireAssuranceStep1 from "./Step1";
import FireAssuranceStep2 from "./Step2";
import FireAssuranceStep3 from "./Step3";
import FireAssuranceStep4 from "./Step4";
import FireAssuranceStep5 from "./Step5";
import crypter from "../../utils/crypter";
import { CookieUtils, Alert, IdentityUtils } from "../../utils";
import moment from "moment";
import ConsentPage from "./consent";

class FireAssurancePage extends Component {
  state = {
    showErroModal: false,
    errorTitle: "Payment is cancelled.",
    errorMessage: "Your payment session has expired, please return to merchant page and attempt payment again.",
    steps: STEPS,
    page: 0,
    productCode: "MTI06128",

    step1: {
      planList: [
        {
          id: "FR001",
          title: "ทุนประกัน",
          packageCode: "FR001",
          logo: <img src={MoneyLogo1} width="40px" height="40px" alt="Logo1" />,
          insured: 300000.0,
          price: 371.83,
          stamp: 2.0,
          vat: 26.17,
          total: 400.0,
        },
      ],
      selectedPlan: "FR001",
      acceptInsurance: "",
      counter: 1,
      onChangeModel: (object) => this.changeModelStep1(object),
    },
    step2: {
      sIDNo: "",
      sSex: "",
      sInitNameTH: "",
      sFirstNameTH: "",
      sLastNameTH: "",
      sBirthDate: "",
      sOccupation: "",
      sMobile: "",
      sEmail: "",
      sStart_date: "",
      sEnd_date: "",
      sNo: "",
      sMoo: "",
      sSoi: "",
      sRoad: "",
      sProvince: "",
      sDistrict: "",
      sCity: "",
      sZipcode: "",
      sNoOther: "",
      sMooOther: "",
      sSoiOther: "",
      sRoadOther: "",
      sProvinceOther: "",
      sDistrictOther: "",
      sCityOther: "",
      sZipcodeOther: "",
      isOtherAddress: "",
      isOtherBenefit: "",
      acceptInsurance: "",
      benefitType: "",
      benefits: [{ sInit: "", sFirstName: "", sLastName: "", sRelation: "" }],
      legalBenefit: "",
      bankBenefit: "",
      companyBenefit: "",
      sBuilding: "",
      onChangeModel: (object) => this.changeModelStep2Insurance(object),
      onChangeAddressOther: (object) => this.changeModelStep2AddressOther(object),
      onChangeBenefit: (object) => this.changeModelStep2Benefit(object),
      onAddBenefit: (key) => this.onHandleBenefit("Add"),
      onRemoveBenefit: (key) => this.onHandleBenefit("Remove"),
      onChangeDateModel: (date) => this.changeDateModel(date),
      onChangeModelProvinces: (object) => this.changeModelProvinces(object),
    },
    step3: {
      recieveEmail: true,
      recievePost: false,
      confirmInsurance: "",
      onChangeModel: (object) => this.changeModelStep3Insurance(object),
      onNavigate: (object) => this.onNavigate(object),
    },
    step4: {
      paymentModel: {},
    },
    step5: {
      onNavigate: (object) => this.onNavigate(object),
    },
  };

  constructor(props) {
    super(props);
    this.initPage();
  }

  initPage() {
    let stateBack = localStorage.getItem("states_fire");
    let paymentResponse = CookieUtils.getCookie("pay_result_fire");
    if (paymentResponse && stateBack) {
      //decode
      if (window && window.decodeURIComponent) {
        paymentResponse = window.decodeURIComponent(paymentResponse);
        stateBack = window.decodeURIComponent(stateBack);
      }
      paymentResponse = crypter.decode(paymentResponse);
      stateBack = crypter.decode(stateBack);

      //Case Error
      const { payment_result } = paymentResponse;
      const isSuccess = payment_result.success;
      this.state.page = isSuccess ? 5 : 4;
      let { step1, step2, step3, step4 } = this.state;
      step1 = { ...step1, ...stateBack.step1 };
      step2 = { ...step2, ...stateBack.step2 };
      step3 = { ...step3, ...stateBack.step3 };
      step4 = { ...step4, ...stateBack.step4 };

      this.state = {
        ...this.state,
        step1,
        step2,
        step3,
        step4,
        step5: {
          ...paymentResponse,
        },
      };

      if (!isSuccess) {
        this.state.showErroModal = true;
      }
      localStorage.setItem("states_fire", "");
      CookieUtils.setCookie("pay_result_fire", "");
    }
  }

  onShowLoading() {
    this.setState({ ...this.state, loading: true });
  }

  onHideLoading() {
    this.setState({ ...this.state, loading: false });
  }

  onHandleBenefit(type) {
    const { step2 } = this.state;
    const { benefits } = step2 || {};
    if (type === "Add") {
      benefits[1] = {
        sInit: "",
        sFirstName: "",
        sLastName: "",
        sRelation: "",
      };
      step2.benefits = benefits;
      this.setState({ ...this.state, step2 });
    } else if (type === "Remove") {
      step2.benefits = [benefits[0]];
      this.setState({ ...this.state, step2 });
    }
  }

  onNavigate = (page) => {
    if (page === 0) {
      // this.props.history.replace("/");
    } else if (page === 3) {
      const { step2 } = this.state;
      const {
        isOtherAddress,
        sNoOther,
        sMooOther,
        sSoiOther,
        sRoadOther,
        sProvinceOther,
        sDistrictOther,
        sCityOther,
        sZipcodeOther,
      } = step2;
      // if (isOtherAddress === 1) {
      //   step2.sNo = sNoOther;
      //   step2.sMoo = sMooOther;
      //   step2.sSoi = sSoiOther;
      //   step2.sRoad = sRoadOther;
      //   step2.sProvince = sProvinceOther;
      //   step2.sDistrict = sDistrictOther;
      //   step2.sCity = sCityOther;
      //   step2.sZipcode = sZipcodeOther;
      // }
      if (!this._validForm() || !this._validEmail()) {
        return false;
      }
    } else if (page === 4) {
      this._onVerifyOrder();
      return;
    }
    this.setState({ ...this.state, page }, () => window.scrollTo(0, 0));
  };

  //UI Action step1
  changeModelStep1 = ({ name, value }) => {
    const { step1 } = this.state;
    step1[name] = value;
    this.setState({ ...this.state, step1 });
  };

  changeModelStep2Insurance = ({ name, value }) => {
    const { step2 } = this.state;
    step2[name] = value;
    this.setState({ ...this.state, step2 });
  };
  changeModelStep3Insurance = ({ name, value }) => {
    const { step3 } = this.state;
    step3[name] = value;
    this.setState({ ...this.state, step3 });
  };

  changeModelStep2AddressOther = ({ name, value }) => {
    const { step2 } = this.state;
    step2[name] = value;
    this.setState({ ...this.state, step2 });
  };
  changeModelStep2Benefit = ({ key, name, value }) => {
    const { step2 } = this.state;
    const { benefits } = step2 || {};
    benefits[key][name] = value;
    this.setState({ ...this.state, step2 });
  };

  changeModelProvinces = (addressChange) => {
    const { step2 } = this.state;

    const step2Change = {
      ...step2,
      ...addressChange,
    };
    this.setState({ ...this.state, step2: step2Change });
  };

  changeDateModel = (date) => {
    const { step2 } = this.state;
    step2.sStart_date = date;
    step2.sEnd_date = moment.utc(date).add(1, "years");
    this.setState({ ...this.state, step2 });
  };

  checkDisbledNextButton() {
    const { page } = this.state;
    if (page === 1) {
      const { step1 } = this.state;

      const { selectedPlan, acceptInsurance } = step1 || {};
      if (!selectedPlan || !acceptInsurance) {
        return true;
      } else {
        return false;
      }
    } else if (page === 2) {
      const { step2 } = this.state;
      const {
        sIDNo,
        sSex,
        sInitNameTH,
        sFirstNameTH,
        sLastNameTH,
        sBirthDate,
        sOccupation,
        sMobile,
        sEmail,
        sStart_date,
        sEnd_date,
        sNo,
        sProvince,
        sDistrict,
        sCity,
        sZipcode,
        sNoOther,
        sProvinceOther,
        sDistrictOther,
        sCityOther,
        sZipcodeOther,
        isOtherAddress,
        benefitType,
        benefits,
        legalBenefit,
        bankBenefit,
        companyBenefit,
      } = step2 || {};
      const { sInit, sFirstName, sLastName, sRelation } = benefits;
      if (
        !sIDNo ||
        !sSex ||
        !sInitNameTH ||
        !sFirstNameTH ||
        !sLastNameTH ||
        !sBirthDate ||
        !sOccupation ||
        !sMobile ||
        !sEmail ||
        !sStart_date ||
        !sEnd_date ||
        !sNoOther ||
        !sProvinceOther ||
        !sDistrictOther ||
        !sCityOther ||
        !sZipcodeOther ||
        !isOtherAddress ||
        !benefitType
      ) {
        return true;
      }
      if (isOtherAddress === 2) {
        if (!sNo || !sProvince || !sDistrict || !sCity || !sZipcode) {
          return true;
        }
      }
      if (benefitType.label === "บุคคลธรรมดา") {
        // if (!sInit) {
        //   return true;
        // }
        for (let i = 0; i < benefits.length; i++) {
          if (!benefits[i].sInit || !benefits[i].sFirstName || !benefits[i].sLastName || !benefits[i].sRelation) {
            return true;
          }
        }
      }
      if (benefitType.label === "นิติบุคคล" && !legalBenefit) {
        return true;
      }
      if (benefitType.label === "สถาบันการเงิน") {
        if (!bankBenefit && !companyBenefit) {
          return true;
        }
        if (bankBenefit.value === "000" && !companyBenefit) {
          return true;
        }
      } else {
        return false;
      }
    } else if (page === 3) {
      const { step3 } = this.state;
      const { recieveEmail, recievePost, confirmInsurance } = step3;
      if (!confirmInsurance) {
        return true;
      }
      if (!recieveEmail && !recievePost) {
        return true;
      } else {
        return false;
      }
    }
  }

  _validForm() {
    const { step2 } = this.state;
    const { sIDNo } = step2;

    if (!IdentityUtils.validateIdentity(sIDNo)) {
      return false;
    } else {
      return true;
    }
  }

  _validEmail() {
    const { step2 } = this.state;
    const { sEmail } = step2;
    let check = true;

    if (!IdentityUtils.validateEmail(sEmail)) {
      check = false;
    }
    return check;
  }

  _onVerifyOrder() {
    const { step1, step2, step3 } = this.state;
    const { benefitType, benefits, legalBenefit, bankBenefit, companyBenefit, sStart_date, sEnd_date } = step2;
    const {
      sInitNameTH,
      sFirstNameTH,
      sLastNameTH,

      sInitNameEN,
      sFirstNameEN,
      sLastNameEN,

      sIDNo,
      sSex,
      sEmail,
      sMobile,
      sNationality,
      sBirthDate,
      isOtherAddress,
      sNo,
      sMoo,
      sSoi,
      sRoad,
      sProvince,
      sDistrict,
      sCity,
      sZipcode,
    } = step2;
    const { sNoOther, sMooOther, sSoiOther, sRoadOther, sProvinceOther, sDistrictOther, sCityOther, sZipcodeOther } =
      step2;

    const { recieveEmail, recievePost } = step3;
    const deliveryTo = recieveEmail && recievePost ? "Both" : recieveEmail ? "Email" : "POST";

    const planDetail = step1.planList[0];

    let identityValue = sIDNo.replace(/-/g, "");
    if (!IdentityUtils.validateIdentity(identityValue)) {
      return false;
    }
    let benefit = {};
    if (benefitType && benefitType.label == "บุคคลธรรมดา") {
      benefits.map((be, index) => {
        const seq = index + 1;
        benefit[`objBeneficiary${seq}`] = {
          sBeneficiarySeq: seq,
          sInit: be.sInit ? be.sInit.label : "",
          sFirstName: be.sFirstName ? be.sFirstName : "",
          sLastName: be.sLastName ? be.sLastName : "",
          sRelationID: be.sRelation ? be.sRelation.value : "",
          sRelation: be.sRelation ? be.sRelation.label : "",
        };
      });
    } else if (benefitType && benefitType.label == "นิติบุคคล") {
      const seq = 1;
      benefit[`objBeneficiary${seq}`] = {
        sBeneficiarySeq: seq,
        sInit: "",
        sFirstName: legalBenefit ? legalBenefit : "",
        sLastName: "",
        sRelationID: "",
        sRelation: "",
      };
    } else if (benefitType && benefitType.label == "สถาบันการเงิน") {
      const seq = 1;
      benefit[`objBeneficiary${seq}`] = {
        sBeneficiarySeq: seq,
        sInit: "",
        sFirstName: bankBenefit && bankBenefit.label === BANK_DEFAULT_SELECT ? companyBenefit : bankBenefit.label,
        sLastName: "",
        sRelationID: "",
        sRelation: "",
      };
    }

    //Use Same Address's Assets
    const addressAssets = {
      sNo: sNoOther,
      sMoo: sMooOther,
      sSoi: sSoiOther,
      sRoad: sRoadOther,
      sDistrict: sDistrictOther.label,
      sCity: sCityOther.label,
      sProvince: sProvinceOther.label,
      sZipCode: sZipcodeOther,
    };
    let address = {};
    if (isOtherAddress === 1) {
      address = addressAssets;
    } else {
      address = {
        sNo: sNo,
        sMoo: sMoo,
        sSoi: sSoi,
        sRoad: sRoad,
        sProvince: sProvince.label,
        sDistrict: sDistrict.label,
        sCity: sCity.label,
        sZipcode: sZipcode,
      };
    }

    const objRequest = {
      objMaster: {
        sProductCode: "MTI06128",
        sPackageCode: planDetail.id,
        planName: "ประกันอัคคีภัยสำหรับบ้านอยู่อาศัย (FR001)",
        sPackagePremium: planDetail.price,
        sTotalPremium: parseFloat(planDetail.total),
        sStamp: planDetail.stamp,
        sVat: planDetail.vat,
        sBKOrderNo: CookieUtils.getCookie("app_bk_no"),
        sFromDate: moment(sStart_date).format("YYYY/MM/DD"),
        sToDate: moment(sEnd_date).format("YYYY/MM/DD"),

        sCountriesEN: "THAILAND", // destination country
        sSendDocBy: sEmail, // user's email
        sContactMT: sMobile, // user's phone no.
        sDeliveryTo: deliveryTo,
        lstObjOptional: [],
        // lstObjOptional: [{
        //   sOptionalCode: 'TRV',//planDetail.packageCode,
        //   sOptionalDesc: planDetail.name,
        //   sOptionalPremium: planDetail.total
        // }]
      },
      lstObjApplicantPerson: [
        {
          sApplicantSeq: 1,
          sType: "A",
          sPersonType: "P",
          sInitNameTH: sInitNameTH.value,
          sFirstNameTH: sFirstNameTH,
          sLastNameTH: sLastNameTH,

          sInitNameEN: "",
          sFirstNameEN: "",
          sLastNameEN: "",

          sIDNo: sIDNo ? sIDNo.replace(/-/g, "") : "",
          sIDType: "ID card",
          sSex: sSex,
          sEmail: sEmail,
          sRDConsent: "",
          sNationality: "THA",
          sBirthDate: moment(sBirthDate).format("YYYY/MM/DD"),
          objApplicantAddress: {
            sType: "A",
            ...address,
            // sZipcode: "ไทย"
          },
          ...benefit,
        },
      ],
      lstObjFireAsset: [
        {
          sApplicantSeq: "1",
          objAddress: {
            sType: "",
            sBuilding: "",
            sFloor: "",
            sRoom: "",
            sVillage: "",
            ...addressAssets,
            sCountry: "",
            sAddress1: "",
            sAddress2: "",
            sAddress3: "",
            sAddress4: "",
          },
          objAsset: {
            sBuildingSI: "0",
            sBuildingPREM: "",
            sFurSI: "",
            sPremiumAll: "",
            sRate: "",
            sAssetBlock: "0",
            sAssetLatitude: "",
            sAssetLongtitude: "",
            sAssetType: "บ้านเดี่ยว",
            sAssetStructure: "คอนกรีต",
            sAssetClass: "1",
            sAssetAge: "",
            sAssetRateEst: "",
            sAssetNoOfUnit: "",
            sAssetOwner: "O",
            sInteriorWidth: "",
            sInteriorLength: "",
            sInteriorStorey: "",
            sStoreyNO: "",
            sIsolate: "",
            sInteriorArea: "",
          },
        },
      ],
      objStep: {
        step1,
        step2,
        step3,
      },
    };

    Alert.showLoading();
    OrderService.orderVerify(objRequest)
      .then((res) => {
        Alert.hideLoading();
        if (res.info.bSuccess && res.hash) {
          const { step4 } = this.state;
          step4.paymentModel = res.hash;
          this.setState({ ...this.state, page: 4, step4 }, () => window.scrollTo(0, 0));
        } else if (!res.info.bSuccess) {
          Alert.alertWithTitle("กรุณาทำรายการใหม่อีกครั้ง", res.info.lstObjResultKey[0].resultDesc.sDescTH, "warning");
        }
      })
      .catch((err) => {
        Alert.hideLoading();
      });
  }

  render() {
    const { showErroModal, errorTitle, errorMessage, steps, page, step1, step2, step3, step4, step5 } = this.state;
    const isDisabledNext = this.checkDisbledNextButton();
    const { sStart_date, sEnd_date } = step2;
    const diffDateAssurance = sStart_date && sEnd_date ? moment(sEnd_date).diff(moment(sStart_date), "years") : "-";
    return (
      <Fragment>
        {page > 0 && page < 4 ? <StepToShowComponent steps={steps} currentPage={page} /> : ""}
        {page === 0 && <ConsentPage />}
        {page === 1 && (
          <FireAssuranceProvider value={{ step1 }}>
            <FireAssuranceStep1 />
          </FireAssuranceProvider>
        )}
        {page === 2 && (
          <FireAssuranceProvider value={{ step2, step3, diffDateAssurance }}>
            <FireAssuranceStep2 />
          </FireAssuranceProvider>
        )}
        {page === 3 && (
          <FireAssuranceProvider value={{ step1, step2, step3 }}>
            <FireAssuranceStep3 />
          </FireAssuranceProvider>
        )}
        {page === 4 && (
          <FireAssuranceProvider value={{ step1, step2, step3, step4 }}>
            <FireAssuranceStep4 />
            <div className="graphic">
              <img src={DecoratedGraphic} className="graphic-img" alt="span image" />
              {/* <div className="form-wrapper footer">
                <a
                  href=""
                  className="pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    this.onNavigate(page - 1);
                    return;
                  }}
                >
                  ย้อนกลับ
                </a>
              </div> */}
            </div>
          </FireAssuranceProvider>
        )}
        {page === 5 && (
          <FireAssuranceProvider value={{ step1, step2, step3, step4, step5 }}>
            <FireAssuranceStep5 />
          </FireAssuranceProvider>
        )}
        {page === 0 && (
          <>
            <button
              className="form-control btn-primary floating-buy"
              disabled={isDisabledNext}
              onClick={() => this.onNavigate(page + 1)}
            >
              ซื้อประกัน
            </button>
          </>
        )}
        {page > 0 && page < 4 && (
          <div className="form-wrapper d-flex mt-0 mb-5">
            <button className="form-control" onClick={() => this.onNavigate(page - 1)}>
              ย้อนกลับ
            </button>
            <SpaceBox w="12px" />
            <button
              className="form-control btn-primary"
              disabled={isDisabledNext}
              onClick={() => this.onNavigate(page + 1)}
            >
              ถัดไป
            </button>
          </div>
        )}
        <PaymentErrorModalComponent
          show={showErroModal}
          title={errorTitle}
          message={errorMessage}
          hideModal={() => this.setState({ ...this.state, showErroModal: false })}
        />
      </Fragment>
    );
  }
}

export default withRouter(FireAssurancePage);
